module.exports = __webpack_public_path__ + "img/7.92a734d0.jpg";